export class ListDailySnapshotsResponse {
    'dailySnapshots';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dailySnapshots",
            "baseName": "dailySnapshots",
            "type": "Array<DailySnapshotData>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListDailySnapshotsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
